import React, { forwardRef } from 'react';
import { Input as AntInput } from 'antd';
import { useTranslation } from 'react-i18next';
import InputType from '../../enums/inputType';
const Input = forwardRef(({ type = InputType.Text, placeholder, onBlur, onChange, onFocus, value, automationId, className, disabled = false, readOnly = false, autoFocus = false }, ref) => {
    const { t: translate } = useTranslation();
    return (<AntInput type={type} placeholder={translate(placeholder)} onBlur={onBlur} onChange={onChange} onFocus={onFocus} value={value} className={className} disabled={disabled} autoFocus={autoFocus} readOnly={readOnly} data-automation-id={automationId} ref={ref}/>);
});
export default Input;
